import app from 'flarum/forum/app';
import {extend} from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import GlobalSearchState from 'flarum/forum/states/GlobalSearchState';
import listItems from 'flarum/common/helpers/listItems';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import TagHero from 'flarum/tags/components/TagHero';

export class FeedbackBoardIndex extends IndexPage {
	oninit(vnode) {
		super.oninit(vnode);

		this.bodyClass = 'Feedback--index';
	}

	view() {
		return (
			<div className="IndexPage">
				{this.hero()}
				<div className="container">
					<div className="sideNavContainer">
						<nav className="IndexPage-nav sideNav">
							<ul>{listItems(this.sidebarItems().toArray())}</ul>
						</nav>
						<div className="IndexPage-results sideNavOffset">
							<DiscussionList state={app.discussions}/>
						</div>
					</div>
				</div>
			</div>
		);
	}

	hero() {
		const tag = app.store.getBy('tags', 'slug', app.data.feedbackTag);
		if (tag) {
			return <TagHero model={tag}/>;
		}
	}
}

app.initializers.add('gg-feedback', (app) => {
	app.routes.feedback = {path: '/feedback', component: FeedbackBoardIndex};

	extend(IndexPage.prototype, 'navItems', function (items) {
		const params = app.search.stickyParams();

		items.add(
			'feedback',
			LinkButton.component(
				{
					href: app.route('feedback', params),
					icon: 'fas fa-angle-double-up',
				},
				'Najwięcej głosów',
			),
			200,
		);
	});

	extend(IndexPage.prototype, 'setTitle', function () {
		if (app.current.get('routeName') === 'feedback') {
			app.setTitle('Najwięcej głosów');
		}
	});

	extend(GlobalSearchState.prototype, 'params', function (params) {
		// We can't set `q` here directly, as that would make the search bar
		// think that text has been entered, and display the "clear" button.
		params.onFeedback = app.current.get('routeName') === 'feedback';
	});

	extend(DiscussionListState.prototype, 'requestParams', function (params) {
		if (this.params.onFeedback) {
			params.filter ||= {};

			params.sort = app.data.feedbackSort;
			if (params.filter.q) {
				params.filter.q += ' ' + app.data.feedbackSearchQuery;
			} else {
				params.filter.q = app.data.feedbackSearchQuery;
			}
		}
	});
});
